import React from "react";
import styled from "styled-components";
import { GoCheck } from "react-icons/go";

const InputRadioCont = styled.div`
  display: flex;
  .radioI {
    height: ${(props) => props.heightR};
    width: ${(props) => props.widthR};
    background: #9d9d9f;
    border: 3px solid #9d9d9f;
    border-radius: 50%;
    transition: ease-in-out 0.2s;
    cursor: pointer;
    display: flex;
    color: #9d9d9f;
    font-size: ${(props) => props.fontSizeR};
    align-items: center;
    justify-content: center;
  }
  .dNone {
    display: none;
    &:checked + label {
      color: ${(props) => props.colorIcon};
      background: ${(props) => props.color};
      border: 3px solid ${(props) => props.borderColor};
    }
  }
`;

const InputRadio = ({
  color = "#297A8E",
  register,
  name,
  forId,
  value,
  icon = false,
  fontSize = "16px",
  colorIcon = "white",
  borderColor = "black",
  width = "30px",
  height = "30px",
}) => {
  return (
    <InputRadioCont
      color={color}
      fontSizeR={fontSize}
      colorIcon={colorIcon}
      borderColor={borderColor}
      widthR={width}
      heightR={height}
    >
      <input
        type="radio"
        name={name}
        id={forId}
        value={value}
        className="dNone"
        ref={register}
      />
      <label htmlFor={forId} className="radioI">
        {" "}
        {icon && <GoCheck />}{" "}
      </label>
    </InputRadioCont>
  );
};
export default InputRadio;
